import { Box, Stack, Typography } from "@mui/material";
import { memo, useContext } from "react";
import { useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import CustomCheckbox from "../../../components/checkbox";
import { AppContext } from "../../../lib/Context";
import {
  handleCheckAllDataFill,
  selectedContractLength,
} from "../../../utils/helper";

const ContractLength = () => {
  const location = useLocation();
  const {
    contractLength: contract,
    setContractLength: setContract,
    handleResetData,
    cliData,
    showAllContractLengths,
  } = useContext(AppContext);
  const hasSomeData = handleCheckAllDataFill(cliData);
  const isDetailPage = location.pathname === "/prospect-details";

  // New leads / new contracts: only availableForNew.
  // Legacy contracts (showAllContractLengths): all options including 12/18.
  const visibleOptions = contract
    .map((val, ind) => ({ ...val, ind }))
    .filter((val) =>
      showAllContractLengths ? true : val.availableForNew !== false
    );

  const handleSelectContract = (ind) => {
    if (selectedContractLength(contract) !== undefined && hasSomeData) {
      return handleOpenConfirmationDialog(ind);
    }

    let tempArray = contract.map((val, index) => {
      return { ...val, isSelected: ind === index ? !val.isSelected : false };
    });
    setContract(tempArray);
  };

  const handleOpenConfirmationDialog = (ind) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Changing the contract length will delete the previous data, and this action cannot be undone.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        handleResetData(false);
        let tempArray = contract.map((val, index) => {
          return {
            ...val,
            isSelected: ind === index ? !val.isSelected : false,
          };
        });
        setContract(tempArray); // Update contract selection
        Swal.fire({
          title: "Deleted!",
          text: "Your data has been deleted.",
          icon: "success",
        });
      }
    });
  };

  return (
    <Box my={3}>
      <Typography variant="h6" color={"text.charcoalGrey"}>
        Contract Length
      </Typography>
      <Stack
        mt={2}
        direction={"row"}
        alignItems={"center"}
        spacing={1.5}
        flexWrap={"wrap"}
      >
        {visibleOptions.map((val) => (
          <Stack
            key={val.ind}
            direction={"row"}
            alignItems={"center"}
            spacing={1}
          >
            <CustomCheckbox
              isChecked={val.isSelected}
              handleChecked={() => {
                if (!isDetailPage) {
                  handleSelectContract(val.ind);
                }
              }}
            />
            <Typography
              variant="body1"
              fontStyle={"italic"}
              lineHeight={"normal"}
            >
              {val.title}
            </Typography>
          </Stack>
        ))}
      </Stack>
    </Box>
  );
};

export default memo(ContractLength);
